import { ReactNode } from "react";
import { Card, Col } from "react-bootstrap";
import "./displayItem.scss";

type Props = {
  children?: ReactNode;
};

export const DisplayItem = ({ children }: Props) => {
  return (
    <Col className="mt-4 text-white">
      <Card className="display-item-card bg-success shadow rounded-1 h-100">{children}</Card>
    </Col>
  );
};
